import React from "react";
import Icons from "../../icons/icons.svg";
import PropTypes from 'prop-types';

const Icon = ({
    name,
    color,
    size,
    className,
    value,
    onClick
}) => {
    const handleOnClick = () => {
        if (onClick) {
            onClick(name, value)
        }
    }
    
    return (
        <svg onClick={handleOnClick} className={`${className} io-icon-${name}`} fill={color} width={size} height={size}>
            <use href={`${Icons}#icon-${name}`} />
        </svg>
    );
}

Icon.defaultProps = {
    size: 32,
    color: '#000',
    className: '',
    onClick: null,
    value: null
}

Icon.propTypes = {
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.number,
    onClick: PropTypes.func,
    value: PropTypes.any
};

export default Icon;
